import { useEffect, useState } from 'react'

/**
 * Reports whether the viewport is narrower than the `md` Tailwind
 * breakpoint. Ported from `packages/frontend`.
 *
 * Returns `undefined` on the first render (before the effect has
 * measured the window) so callers can distinguish "not yet known"
 * from "not mobile" and avoid a wrong-layout flash on cold load.
 */
const MOBILE_BREAKPOINT = 768

export function useIsMobile(): boolean | undefined {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
